export function buildActaNavigation(partido, jornada, fallbackSeasonId, minutosJuego) {
  const hasResult = partido.golesCasa !== null &&
    partido.golesCasa !== undefined &&
    partido.golesCasa !== '';
  const idTemporada = partido.idTemporada ??
    partido.idtemporada ??
    jornada?.idTemporada ??
    jornada?.idtemporada ??
    fallbackSeasonId;
  const codActa = partido.codacta ?? partido.codActa ?? partido.idActa;

  if (!hasResult || !idTemporada || !codActa) {
    return null;
  }

  const params = new URLSearchParams({
    idTemporada: String(idTemporada),
    codActa: String(codActa),
  });

  return {
    pathname: `/actaPartido?${params.toString()}`,
    state: {
      partido,
      idTemporada,
      codActa,
      minutosJuego: minutosJuego || partido.minutosJuego,
    },
  };
}
